class AddonTaskPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'addon_task.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'addon_task._m';

    // Access archived addon tasks
    static ACCESS_ARCHIVE = 'addon_task.access.archive';

    // Create addon task checkout
    static CREATE_CHECKOUT = 'addon_task.create.checkout';

    // Create addon task checkout with custom parameters
    static CREATE_CHECKOUT_CUSTOM = 'addon_task.create.checkout.custom';

    // Manually create addon task
    static CREATE_MANUAL = 'addon_task.create.manual';

    // Update addon task
    static UPDATE = 'addon_task.update';

    // Archive addon task
    static ARCHIVE = 'addon_task.archive';

    // Restore archived addon task
    static RESTORE = 'addon_task.restore';
}

export default AddonTaskPermission;
